/**
 * The Naked Tiger cart drawer extras
 * - Countdown timer ("Your offer is reserved for")
 * - "Add" buttons in "Complete the look"
 * - Bin icon that removes an item
 */
(function () {
  'use strict';

  var TIMER_KEY = 'ntCartTimerEnd';
  var timerEndFallback = null;
  var giftAdding = false;

  function url(name, fallback) {
    var r = window.routes || {};
    return (r[name] || fallback) + '.js';
  }

  function postJSON(endpoint, data) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          throw new Error(json.description || json.message || 'Something went wrong. Please try again.');
        }
        return json;
      });
    });
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function showError(message) {
    var el = document.getElementById('CartDrawer-CartErrors');
    if (el) el.textContent = message;
  }

  /* ---------- Timer ---------- */

  function readTimerEnd() {
    try {
      var stored = parseInt(window.sessionStorage.getItem(TIMER_KEY), 10);
      if (stored) return stored;
    } catch (e) {}
    return timerEndFallback;
  }

  function saveTimerEnd(value) {
    timerEndFallback = value;
    try {
      window.sessionStorage.setItem(TIMER_KEY, String(value));
    } catch (e) {}
  }

  function updateTimer() {
    var el = document.querySelector('#CartDrawer [data-nt-timer]');
    if (!el) return;

    var minutes = parseFloat(el.getAttribute('data-minutes')) || 0;
    if (minutes <= 0) {
      el.hidden = true;
      return;
    }

    var end = readTimerEnd();
    var drawer = getDrawer();
    var drawerOpen = drawer && drawer.classList.contains('active');

    // The countdown starts the first time the shopper sees the drawer
    if (!end && drawerOpen) {
      end = Date.now() + minutes * 60000;
      saveTimerEnd(end);
    }

    var secondsLeft = end ? Math.round((end - Date.now()) / 1000) : Math.round(minutes * 60);
    if (secondsLeft <= 0) {
      el.hidden = true;
      return;
    }

    var m = Math.floor(secondsLeft / 60);
    var s = secondsLeft % 60;
    var value = el.querySelector('[data-nt-timer-value]');
    if (value) value.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    el.hidden = false;
  }

  /* ---------- "Complete the look" Add buttons ---------- */

  function addToCart(button, variantId) {
    if (button.disabled) return;
    var isGift = button.hasAttribute('data-nt-gift-add');
    if (isGift && giftAdding) return;
    if (isGift) giftAdding = true;
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    showError('');

    postJSON(url('cart_add_url', '/cart/add'), {
      items: [{ id: variantId, quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
      .then(function (state) {
        var drawer = getDrawer();
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        }
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = label;
        showError(error.message);
      })
      .finally(function () {
        if (isGift) giftAdding = false;
      });
  }

  /* ---------- Bin icon: removes the item ---------- */

  function removeLine(button) {
    var line = parseInt(button.getAttribute('data-nt-line'), 10);
    if (!line) return;

    var row = button.closest('.cart-item');
    button.disabled = true;
    if (row) row.style.opacity = '0.5';
    showError('');

    postJSON(url('cart_change_url', '/cart/change'), {
      line: line,
      quantity: 0,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
      .then(function (state) {
        var drawer = getDrawer();
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
          drawer.classList.toggle('is-empty', state.item_count === 0);
        }
      })
      .catch(function (error) {
        button.disabled = false;
        if (row) row.style.opacity = '';
        showError(error.message);
      });
  }

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('#CartDrawer [data-nt-line]');
    if (removeButton) {
      event.preventDefault();
      removeLine(removeButton);
      return;
    }

    var addButton = event.target.closest('#CartDrawer [data-nt-add]');
    if (!addButton) return;

    event.preventDefault();
    var card = addButton.closest('.nt-card, .nt-gift-picker');
    var select = card ? card.querySelector('[data-nt-variant-select]') : null;
    var variantId = parseInt(select ? select.value : addButton.getAttribute('data-variant-id'), 10);
    if (variantId) addToCart(addButton, variantId);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('#CartDrawer .nt-gift-picker [data-nt-variant-select]')) return;
    var button = event.target.closest('.nt-gift-picker').querySelector('[data-nt-gift-add]');
    button.disabled = !event.target.value || giftAdding;
  });


  var giftDialog = null;
  var giftDialogBusy = false;
  var giftDialogReturnFocus = null;

  function closeGiftDialog() {
    if (!giftDialog || giftDialogBusy) return;
    giftDialog.close();
    giftDialog.remove();
    giftDialog = null;
    if (giftDialogReturnFocus && giftDialogReturnFocus.isConnected) giftDialogReturnFocus.focus();
  }

  function openGiftDialog(picker) {
    if (giftDialog && giftDialog.open) return;
    giftDialogReturnFocus = document.activeElement;
    var dialog = document.createElement('dialog');
    dialog.className = 'nt-gift-dialog';
    dialog.style.cssText = 'width:min(420px,calc(100% - 32px));box-sizing:border-box;border:0;padding:24px;color:#111;background:#fff;max-height:90vh;overflow:auto;';
    var title = document.createElement('h2');
    title.id = 'NTGiftDialogTitle';
    title.textContent = picker.dataset.giftTitle;
    title.style.cssText = 'font-size:21px;line-height:1.3;margin:0 32px 20px 0;';
    dialog.setAttribute('aria-labelledby', title.id);
    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = '×';
    close.setAttribute('aria-label', picker.dataset.giftClose);
    close.style.cssText = 'position:absolute;right:12px;top:8px;border:0;background:none;font-size:28px;cursor:pointer;';
    close.addEventListener('click', closeGiftDialog);
    var select = picker.querySelector('select').cloneNode(true);
    select.id = 'NTGiftDialogVariant';
    select.removeAttribute('data-nt-variant-select');
    select.style.cssText = 'display:block;width:100%;padding:12px;margin-bottom:12px;background:#fff;color:#111;border:1px solid #ccc;';
    select.setAttribute('aria-label', picker.querySelector('label').textContent.trim());
    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = picker.dataset.giftContinue;
    button.disabled = !select.value;
    button.style.cssText = 'width:100%;padding:14px;background:#e54821;color:#fff;border:0;font-weight:700;cursor:pointer;';
    var error = document.createElement('p');
    error.setAttribute('role', 'alert');
    error.style.cssText = 'color:#b00020;margin:12px 0 0;';
    select.addEventListener('change', function () { button.disabled = !select.value || giftDialogBusy; });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeGiftDialog();
    });
    button.addEventListener('click', function () {
      if (!select.value || giftDialogBusy || giftAdding) return;
      giftDialogBusy = true;
      giftAdding = true;
      button.disabled = true;
      select.disabled = true;
      close.disabled = true;
      error.textContent = '';
      postJSON(url('cart_add_url', '/cart/add'), {
        items: [{ id: Number(select.value), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      }).then(function () {
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        window.location.assign(root + 'checkout');
      }).catch(function (failure) {
        giftDialogBusy = false;
        giftAdding = false;
        button.disabled = false;
        select.disabled = false;
        close.disabled = false;
        error.textContent = failure.message;
      });
    });
    dialog.append(close, title, select, button, error);
    document.body.appendChild(dialog);
    giftDialog = dialog;
    dialog.showModal();
    select.focus();
  }

  function requireGiftBeforeCheckout(event) {
    var checkoutClick = event.type === 'click' && event.target.closest('#CartDrawer-Checkout');
    var checkoutSubmit = event.type === 'submit' && event.target.id === 'CartDrawer-Form';
    if (!checkoutClick && !checkoutSubmit) return;
    var picker = document.querySelector('#CartDrawer .nt-gift-picker');
    if (!picker) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!giftAdding) openGiftDialog(picker);
  }

  document.addEventListener('click', requireGiftBeforeCheckout, true);
  document.addEventListener('submit', requireGiftBeforeCheckout, true);

  /* ---------- Wiring ---------- */

  document.addEventListener('cart:refresh', updateTimer);

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, updateTimer);
    }
    updateTimer();
    setInterval(updateTimer, 1000);
  });
})();